var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 25,
    viewBox: "0 0 11 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42405 12.5986V24.6848C2.42405 24.8589 2.55705 25 2.72252 25H6.97304C7.13726 25 7.27089 24.8589 7.27089 24.6848V12.4014H10.3531C10.5079 12.4014 10.6372 12.2762 10.6497 12.1133L10.9463 8.41245C10.9607 8.2285 10.8233 8.07092 10.6491 8.07092H7.27089V5.44479C7.27089 4.82963 7.74359 4.33117 8.32618 4.33117H10.7015C10.8664 4.33117 11 4.19007 11 4.01601V0.315162C11 0.141098 10.8664 0 10.7015 0H6.68767C4.33356 0 2.42405 2.01625 2.42405 4.5026V8.07092H0.298479C0.133629 8.07092 0 8.21202 0 8.38542V12.0869C0 12.2603 0.133629 12.4014 0.298479 12.4014H2.42405V12.5986Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.02b369fccabbc4397091eb23c0af53e6.svg";
export { ForwardRef as ReactComponent };